export default (resultsRequestData, payload) => {
    const { verticalId, ...requestData } = payload;

    return {
        resultsRequestData: {
            ...resultsRequestData,
            [payload.verticalId]: requestData,
        },
    };
};
